import React from 'react';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';

const propArray = ['ResponsibleFunctionId'];

const LibraryFunctionDataReviewChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              ...removePropertiesFromObject(oldRecord, propArray),
              ResponsibleFunction: oldItem?.responsibleFunction != null ? oldItem?.responsibleFunction.name : null,
          }
        : oldRecord;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, propArray),
              ResponsibleFunction: newItem?.responsibleFunction != null ? newItem?.responsibleFunction.name : null,
          }
        : newRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export { LibraryFunctionDataReviewChangeGrid };
